import { useState } from 'react'
import { ContainerWrapper } from '../Container'
import SectionHeadingWrapper from './SectionHeadingWrapper'
import SectionHeading from './SectionHeading'
import { useRouter } from 'next/router'
import WhiteButton from '../Buttons/WhiteButton'
import BookACallButton from '../Buttons/Specials/BookACallButton'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

const BETTER_DIRECT_MAIL_MODAL_PROPS = {
    formName: 'Better Direct Mail Strategy Call',
}

const ACCENTS = {
    orange: {
        border: 'border-[#ED5C2F]',
        text: 'text-[#ED5C2F]',
        chevron: '#ED5C2F',
        bgAnswer: 'bg-[#ED5C2F]',
        shadow: 'shadow-[0_2px_7px_0_rgba(0,0,0,0.36)]',
    },
    blue: {
        border: 'border-[#2f6bff]',
        text: 'text-[#2f6bff]',
        chevron: '#2f6bff]',
        bgAnswer: 'bg-[#fff5ec]',
        shadow: 'shadow-[0_10px_24px_rgba(47,107,255,0.10)]',
    },
}

const Chevron = ({ open, color = '#f05a2b' }) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 512 512"
        aria-hidden="true"
        fill={color}
        className={`transition-transform h-5 w-5 ${
            open ? 'rotate-180' : 'rotate-0'
        }`}
        xmlns="http://www.w3.org/2000/svg">
        <path d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"></path>
    </svg>
)

function FAQItem({ item, idx, isOpen, toggle }) {
    const accent = ACCENTS['orange']

    return (
        <div
            className={`rounded-xl overflow-hidden ${accent.shadow} ${
                isOpen ? '' : `border-2 ${accent.border}`
            } transition`}>
            {/* Header button */}
            <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={`faq-panel-${idx}`}
                id={`faq-button-${idx}`}
                onClick={toggle}
                className={`w-full flex items-center justify-between text-left ${
                    isOpen ? 'px-5 py-4' : 'px-5 py-3'
                }`}>
                <span
                    className={`w-[92%] md:[100%] md:max-w-[466px] font-semibold text-xl ${accent.text}`}>
                    {item.question}
                </span>
                <Chevron open={isOpen} color={accent.chevron} />
            </button>

            {/* Answer panel */}
            <div
                id={`faq-panel-${idx}`}
                role="region"
                aria-labelledby={`faq-button-${idx}`}
                className={`grid transition-all duration-200 ease-out ${
                    isOpen
                        ? 'grid-rows-[1fr] opacity-100 px-5 bg-[linear-gradient(180deg,#FED7AA00_0%,#FFF8E9_100%)]'
                        : 'grid-rows-[0fr] opacity-0 px-0'
                }`}>
                <div
                    className={`overflow-hidden ${
                        isOpen ? 'mb-5 py-4' : 'mb-0'
                    }`}>
                    <div
                        className="text-black text-lg font-normal [&_strong]:font-semibold [&_a]:underline"
                        dangerouslySetInnerHTML={{ __html: item.answerHtml }}
                    />
                </div>
            </div>
        </div>
    )
}

const WithBenefits = ({ children }) => {
    const router = useRouter()

    return (
        <div
            className="pb-28 -mb-[145px]"
            style={{
                backgroundImage: "url('/assets/homepage/service/bg.svg')",
                backgroundPosition: 'bottom center',
                backgroundRepeat: 'no-repeat',
            }}>
            {children}
            <div className="py-16 mt-14 md:mt-32 mx-4 -mb-48 px-3 sm:px-12 lg:px-24 max-w-7xl my-12 olm-gradient rounded-xl md:rounded-lg md:mx-auto">
                <div className="flex flex-col lg:flex-row w-full items-center gap-10">
                    <div className="w-full lg:w-12/12 text-center md:text-left mb-8 md:mb-0 flex flex-col justify-around gap-8">
                        <h2 className="text-4xl md:text-5xl font-bold text-white text-center">
                            Ready to Make the Switch?
                        </h2>
                        <p className="text-center text-white text-lg max-w-3xl mx-auto">
                            Stop settling for slow turnaround, generic designs,
                            and hands-off support. With OLM, you get
                            investor-tested strategies, faster results, and a
                            partner in your corner.
                        </p>
                        <div className="mt-8 text-center w-full mx-auto gap-5 hidden md:flex justify-center">
                            <div className="max-w-fit">
                                <BookACallButton
                                    scheme="white"
                                    Modal={HomepageBookCallLeadModal}
                                    modalProps={BETTER_DIRECT_MAIL_MODAL_PROPS}>
                                    <span className="text-orange-400">
                                        Book My Free Coaching Call
                                    </span>
                                </BookACallButton>
                            </div>
                            <div className="max-w-fit">
                                <WhiteButton
                                    onClick={() => {
                                        router.push('/get-free-samples')
                                    }}>
                                    <span className="text-orange-400">
                                        Switch & Save 15%
                                    </span>
                                </WhiteButton>
                            </div>
                        </div>
                    </div>
                    <div className="mt-8 md:hidden mx-auto w-full">
                        <WhiteButton
                            onClick={() => {
                                router.push('/get-free-samples')
                            }}>
                            <span className="text-orange-400">
                                Get Free Postcard Samples
                            </span>
                        </WhiteButton>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default function SwitchOLMFAQs({
    heading = 'FAQ – Switching to OLM',
    itemsLeft = defaultItemsLeft,
    itemsRight = defaultItemsRight,
}) {
    // independent open state per column
    const [openLeft, setOpenLeft] = useState(() => {
        const s = new Set()
        itemsLeft.forEach((it, i) => it?.defaultOpen && s.add(i))
        return s
    })
    const [openRight, setOpenRight] = useState(() => {
        const s = new Set()
        itemsRight.forEach((it, i) => it?.defaultOpen && s.add(i))
        return s
    })

    const toggleLeft = (idx) =>
        setOpenLeft((prev) => {
            const copy = new Set(prev)
            if (copy.has(idx)) copy.delete(idx)
            else copy.add(idx)
            return copy
        })

    const toggleRight = (idx) =>
        setOpenRight((prev) => {
            const copy = new Set(prev)
            if (copy.has(idx)) copy.delete(idx)
            else copy.add(idx)
            return copy
        })

    return (
        <section aria-labelledby="faqs-heading" className="">
            <div className="py-16 bg-transparent bg-[radial-gradient(at_center_center,#FFF8EA00_0%,#FFF8E9_100%)] rounded-8xl mb-60">
                <div
                    style={{
                        backgroundImage:
                            "url('/assets/better-direct-mail/cta-bg.webp')",
                        backgroundPosition: 'bottom center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                    }}>
                    <ContainerWrapper footer={false}>
                        <SectionHeadingWrapper>
                            <SectionHeading>{heading}</SectionHeading>
                        </SectionHeadingWrapper>
                        <div className="md:flex max-w-[1140px] mx-auto">
                            <div className="md:w-1/2 p-2 space-y-6">
                                {itemsLeft.map((item, idx) => (
                                    <FAQItem
                                        key={`L-${idx}`}
                                        item={item}
                                        idx={`L-${idx}`}
                                        isOpen={openLeft.has(idx)}
                                        toggle={() => toggleLeft(idx)}
                                    />
                                ))}
                            </div>
                            <div className="md:w-1/2 p-2 space-y-6 md:mt-0">
                                {itemsRight.map((item, idx) => (
                                    <FAQItem
                                        key={`R-${idx}`}
                                        item={item}
                                        idx={`R-${idx}`}
                                        isOpen={openRight.has(idx)}
                                        toggle={() => toggleRight(idx)}
                                    />
                                ))}
                            </div>
                        </div>
                        <WithBenefits />
                    </ContainerWrapper>
                </div>
            </div>
        </section>
    )
}

// Defaults split into two columns to match the visual
const defaultItemsLeft = [
    {
        question: 'How do I transfer my campaigns from another provider?',
        answerHtml:
            'It’s simple — just share your current designs, lists, or ideas with us. Our team will recreate or improve your campaigns inside our system, so you don’t lose time or quality.',
        accent: 'orange',
        defaultOpen: true,
    },
    {
        question: 'Will I lose momentum if I switch mid-campaign?',
        answerHtml:
            'Not at all. We can pick up exactly where you left off, refine your messaging, and launch within days — so your pipeline keeps moving without interruption.',
        accent: 'orange',
    },
    {
        question: 'Do you handle list building and targeting?',
        answerHtml:
            'Yes. You can bring your own lists or work with us to build new, highly targeted lists using our recommended criteria (absentee owners, vacants, preforeclosures, etc.).',
        accent: 'orange',
    },
]

const defaultItemsRight = [
    {
        question: 'How does OLM ensure higher response rates than competitors?',
        answerHtml:
            'We combine investor-tested templates, real personalization (handwritten fonts, ink signatures), and precise list targeting with expert coaching. Every campaign is optimized to pull stronger, measurable results.',
        accent: 'orange',
        defaultOpen: true,
    },
    {
        question: 'How fast can I get my first campaign live?',
        answerHtml:
            "Most campaigns go live within 3 business days once your designs and lists are ready. That's significantly faster than the 1–2 week turnaround you’ll see with most providers.",
        accent: 'orange',
    },
    {
        question: 'What if I’m new to direct mail? Will I get help?',
        answerHtml:
            'Absolutely. You’ll be paired with a dedicated marketing coach who will walk you through everything — from list building to mailer selection to campaign tracking — so you never feel stuck.',
        accent: 'orange',
    },
]
